import { Dropdown, message } from "antd";
import React, { useContext, useEffect, useState } from "react";
import {
  BiSearchAlt,
  BiDotsHorizontal,
  BiPencil,
  BiSliderAlt,
  BiTrash,
  BiCopy,
} from "react-icons/bi";
import { Button } from "../../components/Button";
import { Status } from "../../components/Status";
import { ThemeContext } from "styled-components";
import { Page, ClientActions } from "./styles";
import { Load } from "../../components/Load";
import { api } from "../../services/api";
import { Empty } from "../../components/Empty";
import { Pagination } from "../../components/Pagination";
import { CreateClientModal } from "../../components/CreateClientModal";
import { EditClientModal } from "../../components/EditClientModal";
import { AllocateMessageLimitModal } from "../../components/AllocateMessageLimitModal";
import { PermissionComponent } from "../../components/PermissionComponent";
import { ModalCofirm } from "../../components/ModalCofirm";
export interface IClient {
  id: string;
  name: string;
  corporateName?: any;
  email: string;
  password?: string;
  cpfCnpj: string;
  messageLimit: number;
  messageCount: number;
  isBlocked: boolean;
  isPending?: boolean;
  createdAt: Date;
  userId?: string;
}
const Clients = () => {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const theme = useContext(ThemeContext);
  const [searchOpen, setSearchOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [clients, setClients] = useState<IClient[]>([]);
  const [clientToEdit, setClientToEdit] = useState<IClient>({} as IClient);
  const [clientToDelete, setClientToDelete] = useState<IClient>({} as IClient);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limitPerPage, setLimitPerPage] = useState(10);

  const [isCreateClientModalVisible, setICreateClientModalVisible] =
    useState(false);
  const [clientToAllocateMessagesLimit, setClientToAllocateMessagesLimit] =
    useState<IClient>({} as IClient);
  function handleToggleSearch() {
    setSearchOpen(!searchOpen);
  }
  function handleSelectCopyClientId(client: IClient) {
    navigator.clipboard
      .writeText(client.id)
      .then(() => message.success("ID copiado!"))
      .catch(() => {
        message.error("Ocorreu um erro ao copiar o ID.");
      });
  }
  function handleClientActionClick(client: IClient) {
    return (
      <ClientActions>
        <li
          onClick={(ev) => {
            handleSelectEditClientModal(client);
          }}
        >
          <BiPencil />
          Editar
        </li>
        {!client.isPending && (
          <li
            onClick={(ev) => {
              handleSelectCopyClientId(client);
            }}
          >
            <BiCopy />
            Copiar ID
          </li>
        )}

        <PermissionComponent type="USER" caseType={1}>
          <li
            onClick={(ev) => {
              handleOpenMessageAllocateModal(client);
            }}
          >
            <BiSliderAlt />
            Alocar limite
          </li>
        </PermissionComponent>
        <PermissionComponent type="USER" caseType={1}>
          <li
            onClick={(ev) => {
              handleOpenDeleteClientModal(client);
            }}
          >
            <BiTrash />
            Excluir
          </li>
        </PermissionComponent>
      </ClientActions>
    );
  }
  function handleCloseCreateClientModal() {
    setICreateClientModalVisible(false);
  }
  function handleOpenCreateClientModal() {
    setICreateClientModalVisible(true);
  }
  function handleCloseEditClientModal() {
    setClientToEdit({} as IClient);
  }
  function handleEditClient(client: IClient) {
    const oldData = clients;
    const index = oldData.findIndex((value) => value.id === client.id);
    if (index !== -1) {
      oldData[index] = client;
      setClients([...oldData]);
    }
    setClientToEdit({} as IClient);
  }
  function handleSelectEditClientModal(client: IClient) {
    setClientToEdit(client);
  }
  function handleConfirmCreateClientModal(client: IClient) {
    setClients([...clients, {...client, messageCount: 0, messageLimit:0}]);
    setICreateClientModalVisible(false);
  }
  function handleCloseMessageAllocateModal() {
    setClientToAllocateMessagesLimit({} as IClient);
  }
  function handleOpenMessageAllocateModal(client: IClient) {
    setClientToAllocateMessagesLimit(client);
  }
  function handleOpenDeleteClientModal(client: IClient) {
    setClientToDelete(client);
  }
  function handleCloseDeleteClientModal() {
    setClientToDelete({} as IClient);
  }
  function handleDeleteClient() {
    api
      .delete(`clients/${clientToDelete.id}`)
      .then(() => {
        message.success("Cliente excluido com sucesso.");
        const oldData = clients;
        const index = oldData.findIndex((client)=> client.id === clientToDelete.id)
        oldData.splice(index, 1);
        setClients([...oldData])
      })
      .catch((e) => {
        message.error(e.response.data.message);
      })
      .finally(() => handleCloseDeleteClientModal());
  }
  function handleConfirmMessageAllocateModal(client: IClient) {
    const oldData = clients;
    const index = oldData.findIndex((value) => value.id === client.id);
    if (index !== -1) {
      oldData[index] = client;
      setClients([...oldData]);
    }
    setClientToAllocateMessagesLimit({} as IClient);
  }
  function fetchData() {
    api
      .get<[IClient[], number]>("clients", {
        params: {
          size: limitPerPage,
          page: page,
          search,
        },
      })
      .then((response) => {
        const [data, total] = response.data;
        setClients(data);
        setTotalCount(total);
      })
      .catch((e) => {
        message.error(e.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  function handleNextPage() {
    if (page + 1 >= Math.ceil(totalCount / limitPerPage)) {
      return;
    }
    setPage((prevState) => prevState + 1);
  }
  function handlePreviusPage() {
    if (page - 1 < 0) {
      return;
    }
    setPage((prevState) => prevState - 1);
  }
  function handleLastPage() {
    setPage(Math.ceil(totalCount / limitPerPage) - 1);
  }
  function handleFirstPage() {
    setPage(0);
  }
  function handleChangeLimitPerPage(value: number) {
    if (totalCount > 0) {
      if (page + 1 > Math.ceil(totalCount / value)) {
        setPage(Math.ceil(totalCount / value) - 1);
      }
    }
    setLimitPerPage(value);
  }
  function handleSearch(value: string) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      setSearch(value);
      handleFirstPage();
    }, 500);
  }

  useEffect(fetchData, [limitPerPage, page, search]);
  return (
    <Page>
      {isCreateClientModalVisible && (
        <CreateClientModal
          title={"Cadastrar cliente"}
          cancel={handleCloseCreateClientModal}
          confirm={handleConfirmCreateClientModal}
        />
      )}
      {clientToEdit.id && (
        <EditClientModal
          title={"Editar cliente"}
          cancel={handleCloseEditClientModal}
          confirm={handleEditClient}
          client={clientToEdit}
        />
      )}
      {clientToDelete.id && (
        <ModalCofirm
          title="Tem certeza que quer excluir esse cliente?"
          description="O mesmo não podera enviar mensagens."
          confirm={handleDeleteClient}
          cancel={handleCloseDeleteClientModal}
        />
      )}
      {clientToAllocateMessagesLimit.id && (
        <AllocateMessageLimitModal
          title="Alocar limite de mensagens"
          cancel={handleCloseMessageAllocateModal}
          confirm={handleConfirmMessageAllocateModal}
          client={clientToAllocateMessagesLimit}
        />
      )}

      <header>
        <span>Clientes</span>
        <PermissionComponent type="USER" caseType={1}>
          <Button title="Cadastrar" onClick={handleOpenCreateClientModal} />
        </PermissionComponent>
      </header>

      <label className={`search ${searchOpen ? "active" : ""}`}>
        <input
          type="txt"
          placeholder="Pesquisar cliente"
          onChange={(ev) => {
            handleSearch(ev.currentTarget.value);
          }}
        />
        <BiSearchAlt onClick={handleToggleSearch} />
      </label>

      <div className="content">
        {loading ? (
          <div className="loading">
            <Load />
          </div>
        ) : (
          <>
            <table>
              <thead>
                <tr>
                  <th rowSpan={1} colSpan={1}>
                    Nome
                  </th>
                  <th rowSpan={1} colSpan={2}>
                    Nome Corporativo
                  </th>
                  <th rowSpan={1} colSpan={1}>
                    CPF/CNPJ
                  </th>
                  <th rowSpan={1} colSpan={1}>
                    Limite/Usado
                  </th>
                  <th rowSpan={1} colSpan={1}>
                    Status
                  </th>
                  <th></th>
                </tr>{" "}
              </thead>
              <tbody>
                {clients.length ? (
                  clients.map((client) => (
                    <>
                      <tr key={client.id}>
                        <td rowSpan={1} colSpan={1}>
                          {client.name}
                        </td>
                        <td rowSpan={1} colSpan={2}>
                          {client.corporateName}
                        </td>
                        <td rowSpan={1} colSpan={1}>
                          {client.cpfCnpj}
                        </td>
                        <td rowSpan={1} colSpan={1}>
                          {`${client.messageLimit}/${client.messageCount}`}
                        </td>
                        <td rowSpan={1} colSpan={1}>
                          <Status
                            title={
                              client.isPending
                                ? "PENDENTE"
                                : client.isBlocked
                                ? "INATIVO"
                                : "ATIVO"
                            }
                            type={
                              client.isPending
                                ? "PENDING"
                                : client.isBlocked
                                ? "INACTIVE"
                                : "ACTIVE"
                            }
                          />
                        </td>
                        <td rowSpan={1} colSpan={1}>
                          <Dropdown
                            overlay={() => {
                              return handleClientActionClick(client);
                            }}
                            trigger={["click"]}
                            placement="bottomRight"
                          >
                            <BiDotsHorizontal />
                          </Dropdown>
                        </td>
                      </tr>
                    </>
                  ))
                ) : (
                  <tr>
                    <td rowSpan={1} colSpan={6}>
                      <Empty />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination
              totalItems={totalCount}
              first={handleFirstPage}
              last={handleLastPage}
              limitChange={handleChangeLimitPerPage}
              next={handleNextPage}
              prev={handlePreviusPage}
              currentPage={page}
            />
          </>
        )}
      </div>
    </Page>
  );
};
export { Clients };
